import { render, staticRenderFns } from "./OrderSubmissionSubmit.vue?vue&type=template&id=c58e1586&"
import script from "./OrderSubmissionSubmit.vue?vue&type=script&lang=ts&"
export * from "./OrderSubmissionSubmit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports